var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsObject, IsString, IsUUID } from 'class-validator';
export class PreventionEvaluationQuestionFullSizeDto {
    id;
    createdAt;
    updatedAt;
    question;
    preventionEvaluationAnswers;
    index;
    preventionCourseModuleSectionId;
    preventionCourseModuleSection;
    preventionEvaluationResponses;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionEvaluationQuestionFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionEvaluationQuestionFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionEvaluationQuestionFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PreventionEvaluationQuestionFullSizeDto.prototype, "question", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], PreventionEvaluationQuestionFullSizeDto.prototype, "preventionEvaluationAnswers", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PreventionEvaluationQuestionFullSizeDto.prototype, "index", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], PreventionEvaluationQuestionFullSizeDto.prototype, "preventionCourseModuleSectionId", void 0);
__decorate([
    IsObject(),
    Exclude(),
    __metadata("design:type", Function)
], PreventionEvaluationQuestionFullSizeDto.prototype, "preventionCourseModuleSection", void 0);
__decorate([
    IsObject(),
    Exclude(),
    __metadata("design:type", Array)
], PreventionEvaluationQuestionFullSizeDto.prototype, "preventionEvaluationResponses", void 0);
//# sourceMappingURL=prevention-evaluation-question.full-size.dto.js.map